import { useGetDocumentsQuery } from "./PricebookSlice";
import { Searchbar } from "../../common/components/general/Searchbar";
import { useGetUserInfoQuery } from "../../app/rootReducer";
import { DownloadItem } from "../../common/components/general/DownloadItem";
import { DocumentInterface } from "../../common/interfaces/documents/DocumentInterface";
import { DownloadItemSkeleton } from "../../common/components/general/DownloadItemSkeleton";
import { JSX } from "react";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

const PriceBookPageContainer = (): JSX.Element => {
    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };
    const { data: downloads } = useGetDocumentsQuery();
    const { t, isLoading: isTranslationsLoading } = useStringTranslation();

    const translationsLoaded = !isTranslationsLoading && !!activeLanguage;

    const downloadsAmount = downloads?.length || 0;

    let downloadTitle = t("downloads");
    if (downloadsAmount === 1) {
        downloadTitle = t("download");
    }

    return (
        <>
            <div className="p-pricebook">
                <div className="p-pricebook__header">
                    <div className="c-breadcrumbs">
                        {translationsLoaded ? (
                            <>
                                <span>{t("pricebook")}</span>
                                <div className="c-breadcrumbs__arrow">
                                    <img
                                        src="/images/arrow-black.svg"
                                        alt="arrow"
                                    />
                                </div>
                                <span>{t("downloads")}</span>
                            </>
                        ) : (
                            <>
                                <span className="skeleton skeleton-name"></span>
                                <div className="c-breadcrumbs__arrow">
                                    <img
                                        src="/images/arrow-black.svg"
                                        alt="arrow"
                                    />
                                </div>
                                <span className="skeleton skeleton-name"></span>
                            </>
                        )}
                    </div>
                    <Searchbar />
                </div>

                <div className="p-pricebook__content">
                    <div className="p-pricebook__content__header">
                        {translationsLoaded ? (
                            <h2>
                                {downloadsAmount} {downloadTitle}
                            </h2>
                        ) : (
                            <h2 className="skeleton skeleton-title-large" />
                        )}
                    </div>

                    {downloads && downloads.length > 0 ? (
                        <div className="p-pricebook__content__downloads">
                            {downloads.map(
                                (item: DocumentInterface, key: number) => (
                                    <DownloadItem key={key} data={item} />
                                ),
                            )}
                        </div>
                    ) : (
                        <div className="p-pricebook__content__downloads">
                            {Array(5)
                                .fill(0)
                                .map((_, index) => (
                                    <DownloadItemSkeleton key={index} />
                                ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default PriceBookPageContainer;
